"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.resetForm = exports.formSlice = exports.applyMockData = void 0;
var _toolkit = require("@reduxjs/toolkit");
var _thunks = require("./thunks");
var _constants = require("../../constants/constants");
var initialState = {
  felineBreeds: {
    status: _constants.STATUS_PENDING,
    value: []
  },
  canineBreeds: {
    status: _constants.STATUS_PENDING,
    value: []
  },
  medias: {
    status: _constants.STATUS_PENDING,
    value: []
  },
  vets: {
    status: _constants.STATUS_PENDING,
    value: []
  },
  genders: {
    status: _constants.STATUS_PENDING,
    value: []
  },
  titles: {
    status: _constants.STATUS_PENDING,
    value: []
  },
  suburbs: {
    status: _constants.STATUS_PENDING,
    value: []
  }
};
var formSlice = exports.formSlice = (0, _toolkit.createSlice)({
  name: 'form',
  initialState: initialState,
  reducers: {
    resetForm: function resetForm() {
      return initialState;
    }
  },
  extraReducers: function extraReducers(builder) {
    builder.addCase(_thunks.fetchFelineBreeds.fulfilled, function (state, action) {
      state.felineBreeds.value = action.payload;
      state.felineBreeds.status = _constants.STATUS_RESOLVED;
    });
    builder.addCase(_thunks.fetchCanineBreeds.fulfilled, function (state, action) {
      state.canineBreeds.value = action.payload;
      state.canineBreeds.status = _constants.STATUS_RESOLVED;
    });
    builder.addCase(_thunks.fetchMedias.fulfilled, function (state, action) {
      state.medias.value = action.payload;
      state.medias.status = _constants.STATUS_RESOLVED;
    });
    builder.addCase(_thunks.fetchSuburbs.fulfilled, function (state, action) {
      state.suburbs.value = action.payload;
      state.medias.status = _constants.STATUS_RESOLVED;
    });
    builder.addCase(_thunks.fetchTitles.fulfilled, function (state, action) {
      state.titles.value = action.payload;
      state.titles.status = _constants.STATUS_RESOLVED;
    });
    builder.addCase(_thunks.fetchVets.fulfilled, function (state, action) {
      state.vets.value = action.payload;
      state.vets.status = _constants.STATUS_RESOLVED;
    });
    builder.addCase(_thunks.fetchGenders.fulfilled, function (state, action) {
      state.genders.value = action.payload;
      state.genders.status = _constants.STATUS_RESOLVED;
    });
    builder.addCase(_thunks.fetchAndApplyMockData.fulfilled, function (state, action) {
      var _action$payload = action.payload,
        catBreeds = _action$payload.catBreeds,
        dogBreeds = _action$payload.dogBreeds,
        medias = _action$payload.medias,
        genders = _action$payload.genders,
        vets = _action$payload.vets,
        titles = _action$payload.titles,
        suburbs = _action$payload.suburbs;
      state.felineBreeds = {
        value: catBreeds,
        status: _constants.STATUS_RESOLVED
      };
      state.canineBreeds = {
        value: dogBreeds,
        status: _constants.STATUS_RESOLVED
      };
      state.medias = {
        value: medias,
        status: _constants.STATUS_RESOLVED
      };
      state.vets = {
        value: vets,
        status: _constants.STATUS_RESOLVED
      };
      state.genders = {
        value: genders,
        status: _constants.STATUS_RESOLVED
      };
      state.titles = {
        value: titles,
        status: _constants.STATUS_RESOLVED
      };
      state.suburbs = {
        value: suburbs,
        status: _constants.STATUS_RESOLVED
      };
    });
  }
});
var _formSlice$actions = formSlice.actions,
  applyMockData = exports.applyMockData = _formSlice$actions.applyMockData,
  resetForm = exports.resetForm = _formSlice$actions.resetForm;